<template>
  <div class="col-md-12" style="">
    <h4 style="margin-top: 5px">
      Animal Details
      <b-button class="float-right" @click="go_back" variant="danger">
        <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill> Back
      </b-button>
    </h4>

    <hr />
    <div class="col-12" style="margin-top: 30px">
      <b-card-text>
        <center>
          <img src="../assets/ox.jpg" height="250px" /><br />
          <!-- <h7><b>Name:Ox</b></h7
          ><br />
          <h7><b>Type:</b></h7
          ><br />
          <h7><b>Amount:40000</b></h7
          ><br />
          <h7><b>Tag No:</b></h7
          ><br /> -->
        </center>
      </b-card-text>
      <table style="" width="100%" border="0">
        <br />
        
        <tr>
          <td width="45%" style="text-align: left">Tag No</td>
          <td width="1%" style="text-align: left">:</td>
          <td width="54%" style="text-align: left">22</td>
        </tr>

        <tr>
          <td width="45%" style="text-align: left">Type</td>
          <td width="1%" style="text-align: left">:</td>
          <td width="54%" style="text-align: left">OX</td>
        </tr>
        <tr>
          <td width="45%" style="text-align: left">Breed</td>
          <td width="1%" style="text-align: left">:</td>
          <td width="54%" style="text-align: left">Ongole Cattle</td>
        </tr>
        <tr>
          <td width="45%" style="text-align: left">Breed Name</td>
          <td width="1%" style="text-align: left">:</td>
          <td width="54%" style="text-align: left">Ongole Cattle</td>
        </tr>
        <tr>
          <td width="45%" style="text-align: left">Age</td>
          <td width="1%" style="text-align: left">:</td>
          <td width="54%" style="text-align: left">7 Years</td>
        </tr>
        <tr>
          <td width="45%" style="text-align: left">Amount</td>
          <td width="1%" style="text-align: left">:</td>
          <td width="54%" style="text-align: left">30.000</td>
        </tr>

        <br />
        <tr></tr>
        <br />
      </table>
      <div class="btn-group col-12">
        <button
          type="button"
          class="btn btn-xs btn-success col-4"
          @click="handleSell"
        >
          Sell</button
        >&nbsp;
        <button
          type="button"
          class="btn btn-xs btn-primary col-4"
          @click="send_enquiry"
        >
          Edit/Update</button
        >&nbsp;
        <button
          type="button"
          class="btn btn-xs btn-danger col-4"
          @click="add_to_cart"
        >
          Delete
        </button>
      </div>
      <hr />
      <div class="btn-group col-12">
        <button
          type="button"
          class="btn btn-xs btn-success col-6"
          @click="handleSell1"
        >
          Add Vaccination</button
        >&nbsp;
        <button
          type="button"
          class="btn btn-xs btn-primary col-6"
          @click="handleSell2"
        >
          Add Insurance
        </button>
      </div>
      <br />
    </div>
    <br />
  </div>
</template>
<script>
export default {
  data() {
    return {
      tabIndex: 0,
    };
  },
  methods: {
    handleSell() {
      this.$router.push("/home/Add_for_sell");
    },
    go_back() {
      this.$router.go(-1);
    },
    add_to_cart() {
      alert("Added To Cart");
    },
    send_enquiry() {
      alert("Enquiry send to seller");
    },
  },
};
</script>